import { BigModal, TextDefault } from '@awarego-ui/components';
import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import ReportSnapshotForm from '../forms/snapshot/ReportSnapshotForm';
import AddReportFooter from '../forms/ReportFormFooter';
import { useStores } from '../../../hooks/use-stores';

function ReportSnapshotModal({
    isOpen,
    onRequestClose,
    reportsForm,
    lists,
    companyId,
}) {
    const { reportsStore } = useStores();
    const reportType = reportsForm.fields?.reportType?.value || '';
    const isDepartmentManager = reportType === 'department-manager';
    const needsTags = isDepartmentManager;

    useEffect(() => {
        if (isOpen) {
            reportsStore.setError(null);
        }
    }, [isOpen, reportsStore]);

    // Load tags when snapshot modal opens so options are ready as soon as user selects Department Manager
    useEffect(() => {
        if (!companyId || !isOpen) return;
        if (reportsStore.reportTags.length > 0) return;
        reportsStore.loadReportTags(companyId);
    }, [companyId, isOpen, reportsStore, reportsStore.reportTags.length]);

    useEffect(() => {
        if (!needsTags) return;
        if (!isOpen) return;
        try {
            const tagField = reportsForm.$('reportTags');
            if (tagField) {
                const existingExtra = Array.isArray(tagField.extra)
                    ? tagField.extra
                    : [];
                const merged = Array.from(
                    new Set([...existingExtra, ...reportsStore.reportTags])
                ).sort((a, b) =>
                    a.localeCompare(b, undefined, { sensitivity: 'base' })
                );
                tagField.set('extra', merged);
            }
        } catch (err) {
            // reportTags field may not exist
        }
    }, [isOpen, reportsForm, reportsStore.reportTags, needsTags]);

    const handleCancel = () => {
        reportsStore.setError(null);
        onRequestClose();
    };

    return (
        <BigModal
            shouldCloseOnOverlayClick={false}
            isOpen={isOpen}
            onRequestClose={handleCancel}
            heading="Generate snapshot"
            modalContent={
                <>
                    {reportsStore.error && (
                        <TextDefault
                            mb={16}
                            style={{ color: 'var(--color-error, #d32f2f)' }}
                        >
                            {reportsStore.error}
                        </TextDefault>
                    )}
                    <ReportSnapshotForm
                        reportsForm={reportsForm}
                        lists={lists}
                        companyId={companyId}
                    />
                </>
            }
            modalFooterContent={
                <AddReportFooter
                    reportsForm={reportsForm}
                    submitText={'Generate'}
                    onCancel={handleCancel}
                    onSubmit={() => {
                        reportsForm.submit();
                    }}
                />
            }
        />
    );
}

export default observer(ReportSnapshotModal);
